// extracted by mini-css-extract-plugin
export default {"svg":"TrashReservationIcon_svg__jGzsw","active":"TrashReservationIcon_active__eEth8"};